const matchSchema = function matchSchema(name) {
  return ({ SchemaName }) => SchemaName === name;
};

const matchId = function matchId(id) {
  return ({ Id }) => Id === id;
};

const matchTemplate = function matchTemplate(name) {
  return ({ ComponentTemplate }) =>
    ComponentTemplate && ComponentTemplate.TemplateName === name;
};

module.exports = {
  matchId,
  matchSchema,
  matchTemplate
};
